export const limitsChange = {
    showInfoMessage: false,
    showInfoMessageDelay: false,
    showRemovingTmpLimitsMessage: false,
    temporaryValidUntil: false,
    allowZeroLimits: false,
    enforceZeroPrecision: false,
    validations: {
        relyOnMaximumTemporaryLimitForTemporaryLimitValidation: false,
        INTERNET: {
            biggerThanPOS: false,
        },
        TOTAL: {
            biggerThanAll: false,
        },
    },
    hasAllowedLimits: false,
};
